import React from 'react';

type ProfileIconProps = {
  width?: string;
  height?: string;
  color?: string;
  style?: React.CSSProperties;
};

function ProfileIcon({
  width = '32',
  height = '34',
  color = '#6267AC',
  style,
}: ProfileIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ ...style }}
    >
      <path
        d='M16.0001 22C10.7166 22 6.01807 24.5511 3.02673 28.5099C2.38292 29.362 2.06101 29.788 2.07154 30.3638C2.07967 30.8086 2.35901 31.3698 2.70902 31.6445C3.16206 32 3.78986 32 5.04546 32H26.9547C28.2103 32 28.8381 32 29.2911 31.6445C29.6411 31.3698 29.9205 30.8086 29.9286 30.3638C29.9391 29.788 29.6172 29.362 28.9734 28.5099C25.9821 24.5511 21.2835 22 16.0001 22Z'
        stroke={color}
        stroke-width='3'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M16.0001 17C20.1422 17 23.5001 13.6421 23.5001 9.5C23.5001 5.35786 20.1422 2 16.0001 2C11.8579 2 8.50008 5.35786 8.50008 9.5C8.50008 13.6421 11.8579 17 16.0001 17Z'
        stroke={color}
        stroke-width='3'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default ProfileIcon;
